export enum BtmReturnRequestCategory {
    Unspecified = "Unspecified",
    Voluntary = "Voluntary",
    Involuntary = "Involuntary",
}

export const BuildBtmReturnRequestCategoryFromString = (category: string) => {
    switch (category) {
        case "Voluntary":
            return BtmReturnRequestCategory.Voluntary;
        case "Involuntary":
            return BtmReturnRequestCategory.Involuntary;
        default:
            return BtmReturnRequestCategory.Involuntary;
    }
};
